export const MapModeEum = Object.freeze({
    mode2D: "2d",
    mode3D: "3d"
})